export const enum URLs {
    AbpProd = "https://alphabetplanet.creaza.com/",
    AbpStage = "https://alphabetplanet-stage.creaza.com/",
    BiographyAudio = "https://alphabet-planet-ui.s3.eu-west-1.amazonaws.com/audio-inhabitants",
}